<template>
  <TabsLayout>
    <ElTabPane name="targetingslist" label="定向包管理"></ElTabPane>
    <ElTabPane name="tartencentadd" label="新建腾讯定向包" v-if="$route.name === 'tartencentadd'"></ElTabPane>
    <ElTabPane name="tarkuaishouadd" label="新建磁力引擎定向包" v-if="$route.name === 'tarkuaishouadd'"></ElTabPane>
    <ElTabPane name="tarUCadd" label="新建超级汇川定向包" v-if="$route.name === 'tarUCadd'"></ElTabPane>
    <ElTabPane name="tarbaiduadd" label="新建百度定向包" v-if="$route.name === 'tarbaiduadd'"></ElTabPane>
    <ElTabPane name="ToutiaoTargetingAdd" label="新建巨量引擎定向包" v-if="$route.name === 'ToutiaoTargetingAdd'"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'targetinglayout',
  components: { TabsLayout }
}
</script>
<style lang="scss" scoped></style>
